/* eslint-disable */
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts"
import {
  Box,
  Typography,
  Divider,
  Card,
} from '@mui/material';
import { useAppSelector } from '../../../store/hooks';
import { generateColorFromString } from "../../../utils/generateRandomColor";


const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length > 0) {
    const slice = payload[0].payload;
    return (
      <Box sx={{ bgcolor: 'white', py: 1, px: 2, border: '0.5px grey solid' }}>
        <p><strong>{slice.name}</strong></p>
        <p>Value: {slice.value}</p>
        <p>Avg: {slice.avg}</p>
      </Box>
    );
  }
  return null;
};


const SkiptraceStatsCard = () => {
  const skiptraceStats = useAppSelector(state => state.whiltelabelSlice.skiptraceStats)
  return (
    <Card
      sx={{
        p: 4, borderRadius: 3, width: '100%', height: '100%'
      }}
    >
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 0.1,
          mb: 1,
        }}
      >
        Skiptrace Records Activity
      </Typography>

      <Box sx={{ display: "flex", gap: 4, alignItems: "flex-start", justifyContent: 'space-between' }}>
        <Box sx={{ display: "flex", flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: 0.1,
                mb: 1,
              }}
            >
              Total Records Skiptrace(D)
            </Typography>
            <Typography sx={{ fontSize: 32, fontWeight: 700 }}>{skiptraceStats.totalSkiptrace}</Typography>
          </Box>
          <Divider sx={{ my: 1 }} />
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: 0.1,
                mb: 1,
              }}
            >
              Average Skiptrace Order Size
            </Typography>
            <Typography sx={{ fontSize: 28, fontWeight: 700 }}>{skiptraceStats.avgSkiptraceOrder}</Typography>
          </Box>
        </Box>
        <ResponsiveContainer width="40%" height={180}>
          <PieChart>
            <Pie data={skiptraceStats.data} cx="50%" cy="50%" innerRadius={50} outerRadius={80} dataKey="value">
              {skiptraceStats.data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={generateColorFromString(entry.name)} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </Box>

    </Card>
  )
}

export default SkiptraceStatsCard;